import React from 'react'
import styled from 'styled-components'

const EnergyForecastContainer = styled.div`
    display: flex;
    flex-direction: row;
    `

const MarketTrends = () => {
  return (
    <EnergyForecastContainer>
        MarketTrends
    </EnergyForecastContainer>
  )
}

export default MarketTrends
